<template>
  <v-navigation-drawer v-model="drawer" temporary right app>
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        @click="clickMenu(item)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("userMenu." + item.type)
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Firebase from "firebase";
export default {
  props: ["value"],
  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(newVal) {
        if (this.value !== newVal) this.$emit("input", newVal);
      }
    }
  },
  data: function() {
    return {
      items: [
        {
          type: "home",
          icon: "home",
          url: "/home"
        },
        {
          type: "schedule",
          icon: "fitness_center",
          url: "/traininglist"
        },
        {
          type: "reservation",
          icon: "today",
          url: "/reservationlist"
        },
        {
          type: "eventlist",
          icon: "mdi-message-text",
          url: "/eventlist"
        },
        {
          type: "userinfo",
          icon: "account_box",
          url: "/userinfo"
        },
        {
          type: "logout",
          icon: "exit_to_app",
          url: "/home"
        }
      ]
    };
  },
  methods: {
    clickMenu: async function(item) {
      if (item.type === "logout") {
        await Firebase.auth()
          .signOut()
          .then(() => {
            this.logout();
          });
      } else {
        this.setNextRoot(item);
      }
    },
    logout: async function() {
      this.$store.dispatch(
        "loginStore/loginInfo/loginInfoStore/setUserInfo",
        null
      );
      this.$store.dispatch(
        "loginStore/loginInfo/loginInfoStore/setSignedIn",
        false
      );
    },
    setNextRoot: async function(item) {
      this.$router.push({ path: item.url });
    }
  }
};
</script>
